import { render } from "./TraqrsReadVue.vue?vue&type=template&id=5dfb3f61"
import script from "./TraqrsReadVue.vue?vue&type=script&lang=js"
export * from "./TraqrsReadVue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__